module.exports = __webpack_public_path__ + "img/illuminance.deff7462.svg";